export const StorageKeys = {
  language: "lang",
  token: "token",
  user: "user",
  keepMeSignIn: "keepMeSignIn",
  CMSMode: "CMSMode",
  refreshToken: "refreshToken",
}
